import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { queryClient } from '@hero/clients';
import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useCreateTag = options => {
  const { t } = useTranslation();
  const { showSuccess } = useNotification();

  return useMutation(body => contactServices.createTag(body), {
    ...options,
    onSuccess() {
      showSuccess({
        type: 'toast',
        message: t('tagSuccessfullyCreated')
      });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetTagListKey] });
    }
  });
};
